// extracted by mini-css-extract-plugin
export var container = "index-module--container--i73Um";
export var dl = "index-module--dl--dEOJL";
export var frontImage = "index-module--frontImage--ST+nc";
export var frontImageContainer = "index-module--frontImageContainer--C3ZFN";
export var gradBorder = "index-module--gradBorder--OIO-E";
export var tts = "index-module--tts--H4zaP";
export var ttsContainer = "index-module--ttsContainer--b81z0";
export var variantContainer = "index-module--variantContainer--hmgpS";
export var variantName = "index-module--variantName--C1dE-";
export var variantNames = "index-module--variantNames--BjFrn";
export var variantPrice = "index-module--variantPrice--asVkH";
export var volPricingText = "index-module--volPricingText--n5ikn";